import { render } from "./AnnouncementDetail.vue?vue&type=template&id=4ed3e69c&scoped=true"
import script from "./AnnouncementDetail.vue?vue&type=script&lang=js"
export * from "./AnnouncementDetail.vue?vue&type=script&lang=js"

import "./AnnouncementDetail.vue?vue&type=style&index=0&id=4ed3e69c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ed3e69c"]])

export default __exports__